var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.clipBox
    ? _c("div", [
        _c("div", { staticClass: "sm-function-module-content" }, [
          _c("div", { staticClass: "sm-function-module-sub-section" }, [
            _c("label", { staticClass: "label-container" }, [
              _vm._v("长度(米) :")
            ]),
            _c("div", { staticClass: "sm-solider-input-box" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clipLength,
                    expression: "clipLength"
                  }
                ],
                staticClass: "min-solider",
                staticStyle: { width: "63%" },
                attrs: { min: "0", step: "1", type: "range" },
                domProps: { value: _vm.clipLength },
                on: {
                  __r: function($event) {
                    _vm.clipLength = $event.target.value
                  }
                }
              }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clipLength,
                    expression: "clipLength"
                  }
                ],
                staticClass: "min-solider",
                staticStyle: { width: "34%", height: "25px" },
                attrs: { min: "0", step: "1", type: "number" },
                domProps: { value: _vm.clipLength },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.clipLength = $event.target.value
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "sm-function-module-sub-section" }, [
            _c("label", { staticClass: "label-container" }, [
              _vm._v("宽度(米) :")
            ]),
            _c("div", { staticClass: "sm-solider-input-box" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clipWidth,
                    expression: "clipWidth"
                  }
                ],
                staticClass: "min-solider",
                staticStyle: { width: "63%" },
                attrs: { min: "0", step: "1", type: "range" },
                domProps: { value: _vm.clipWidth },
                on: {
                  __r: function($event) {
                    _vm.clipWidth = $event.target.value
                  }
                }
              }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clipWidth,
                    expression: "clipWidth"
                  }
                ],
                staticClass: "min-solider",
                staticStyle: { width: "34%", height: "25px" },
                attrs: { min: "0", step: "1", type: "number" },
                domProps: { value: _vm.clipWidth },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.clipWidth = $event.target.value
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "sm-function-module-sub-section" }, [
            _c("label", { staticClass: "label-container" }, [
              _vm._v("高度(米) :")
            ]),
            _c("div", { staticClass: "sm-solider-input-box" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clipHeight,
                    expression: "clipHeight"
                  }
                ],
                staticClass: "min-solider",
                staticStyle: { width: "63%" },
                attrs: { min: "0", step: "1", type: "range" },
                domProps: { value: _vm.clipHeight },
                on: {
                  __r: function($event) {
                    _vm.clipHeight = $event.target.value
                  }
                }
              }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clipHeight,
                    expression: "clipHeight"
                  }
                ],
                staticClass: "min-solider",
                staticStyle: { width: "34%", height: "25px" },
                attrs: { min: "0", step: "1", type: "number" },
                domProps: { value: _vm.clipHeight },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.clipHeight = $event.target.value
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "sm-function-module-sub-section" }, [
            _c("label", { staticClass: "label-container" }, [
              _vm._v("旋转(度) :")
            ]),
            _c("div", { staticClass: "sm-solider-input-box" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clipRotate,
                    expression: "clipRotate"
                  }
                ],
                staticClass: "min-solider",
                staticStyle: { width: "63%" },
                attrs: { max: "180", min: "-180", step: "1", type: "range" },
                domProps: { value: _vm.clipRotate },
                on: {
                  __r: function($event) {
                    _vm.clipRotate = $event.target.value
                  }
                }
              }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clipRotate,
                    expression: "clipRotate"
                  }
                ],
                staticClass: "min-solider",
                staticStyle: { width: "34%", height: "25px" },
                attrs: { max: "180", min: "-180", step: "1", type: "number" },
                domProps: { value: _vm.clipRotate },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.clipRotate = $event.target.value
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "sm-function-module-sub-section" }, [
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("裁剪模式:")]
            ),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ClipModelSelected,
                    expression: "ClipModelSelected"
                  }
                ],
                staticClass: "sm-select sm-select-s",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.ClipModelSelected = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              _vm._l(_vm.ClipModels, function(Options) {
                return _c(
                  "option",
                  { key: Options.id, domProps: { value: Options.id } },
                  [_vm._v(_vm._s(Options.name))]
                )
              }),
              0
            )
          ]),
          _c("div", { staticClass: "boxchild" }, [
            _c(
              "button",
              {
                staticClass: "tbtn tbn1",
                attrs: { type: "button" },
                on: { click: _vm.BoxClip }
              },
              [_vm._v("裁剪")]
            ),
            _c(
              "button",
              {
                staticClass: "tbtn",
                attrs: { type: "button" },
                on: { click: _vm.clearBoxClip }
              },
              [_vm._v("清除")]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }